<template>
  <div>
    <wc-page-title title='Financial Reports'></wc-page-title>
    <v-container>
      <v-row>
        <report-title
          style="padding-left: 15px;"
          title='Revenue Report'
          subtitle=''
        ></report-title>
      </v-row>
      <v-row>
      
        <v-col cols='12' md='12'>
          <wc-data-box
            title='Setup'
          >
            <v-card-text>
              <v-row>
                <v-col cols="5">
                  <wc-datepicker
                    label='From date'
                    v-model='fromDate'
                    removeClearOption
                    defaultToday
                  />
                </v-col>
                <v-col cols="5">
                  <wc-datepicker
                    label='To date'
                    v-model='toDate'
                    removeClearOption
                    defaultToday
                  />
                </v-col>
                <v-col class='text-right py-0' cols="2">
                  <v-btn 
                    style='margin-top: 25px;'
                    depressed 
                    class='primary' 
                    @click='generateReport' 
                    :loading='loadingItems'>
                      Generate
                    </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </wc-data-box>
        </v-col>
      </v-row>

      <template v-if='generatedReport'>
          <v-simple-table dense>
            <tbody>
              <template v-for='(report_key, report_value) in this.revenue_report'>
                <template v-if='report_value === "Revenue Report" || report_value === "Expense"'>
                <tr :key='report_value'>
                  <td style='border-bottom: solid 1px;' class='pl-0' colspan='3'>
                    <report-header :text='report_value'></report-header>
                  </td>
                </tr>
                  <template v-for='(accounts, index) in report_key'>
                    <template v-for='(key, value) in accounts'>
                      <template v-if='value === "Total Revenue" || value === "Total Expenses"'>
                        <tr :key='index + "_" + value + "_" + report_value'>
                          <td>
                            <span class='font-weight-bold text-uppercase'>
                              {{value}}
                            </span>
                          </td>
                          <td></td>
                          <td align="right" width="100">{{key | decMoney }}</td>
                        </tr>
                      </template>
                      <template v-else>
                        <template v-if='value == "Group Total"'>
                          <tr :key='index + "_" + value + "_" + report_value' >
                            <td style='padding-left: 35px;'>
                              <span class='font-weight-bold text-uppercase'> 
                                {{value}}
                              </span>
                            </td>
                            <td><span></span></td>
                            <td>
                              <span class='font-weight-bold text-uppercase'> 
                                {{key | decMoney}}
                              </span>
                            </td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr :key='index + "_" + value + "_" + report_value' >
                            <td>
                              <span class='font-weight-bold text-uppercase'> 
                                {{value}}
                              </span>
                            </td>
                            <td><span></span></td>
                            <td></td>
                          </tr>
                          <template v-for='(account, i) in key'>
                            <tr :key='i + "_" + value + "_" + account.name' @click='openLineItemsDialog(account)'>
                            <td style='padding-left: 35px;'>
                              <span> 
                                {{account.name}}
                              </span>
                            </td>
                            <td align="right" width="100">
                              <span>
                                {{account.value | decMoney}} 
                              </span>
                            </td>
                            <td></td>
                          </tr>
                          </template>
                        </template>
                      </template>
                    </template>
                    
                  </template>
                </template>
                <template v-else>
                  <tr :key='report_value'>
                    <td>
                    <report-header :text='report_value'></report-header>
                    </td>
                    <td>
                    </td>
                    <td>
                    <report-header :text='report_key'></report-header>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </v-simple-table>
      </template>
    </v-container>
    <invoice-line-item-dialog 
      :line_items='line_items'
      :title='line_items_title'
      :show='show_transaction_dialog'
      :total='line_item_total'
      @close='closeLineItemsDialog'
    />
  </div>
</template>

<script>
import accountingAPI from '@/api/accounting';
import managementAPI from '@/api/management';
import ReportHeader from '@/modules/management/components/financial_reports/ReportHeader';
import ReportTitle from '@/modules/management/components/financial_reports/ReportTitle';
import InvoiceLineItemsDialog from './revenue_report/InvoiceLineItemsDialog.vue';
import moment from 'moment';

export default {
  name: 'revenue-report',
  data: () => ({
    fromDate: moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    invoices: [],
    revenue_report: {},
    loadingItems: false,
    generatedReport: false,
    line_items_title: '',
    line_items: [],
    loading_items: false,
    show_transaction_dialog: false,
    line_item_total: 0,
    search: '',
    items: [],
    headers: [
      { text: 'Date Sent', value: 'date_sent' },
      { text: 'Due Date', value: 'date_due' },
      { text: 'Division', value: 'division_display' },
      { text: 'Bill To', value: 'bill_to_obj.name_display' },
      { text: 'Invoice Total', value: 'original_amount', align: 'right' }
    ]
  }),
  methods: {
    async generateReport () {
      this.loadingItems = true;
      this.search = '';
      this.revenue_report = await managementAPI.getRevenueReport(this.fromDate, this.toDate);
      this.invoices = await accountingAPI.getRevenueInvoices(this.fromDate, this.toDate);
      this.loadingItems = false;
      this.generatedReport = true;
    },
    openInvoice (inv) {
      const link = document.createElement('a');
      const invURL = this.$router.resolve({ name: 'InvoiceOverview', params: { id: inv.id } });
      link.target = '_blank';
      link.href = invURL.href;
      link.click();
    },
    removeGST (amount) {
      return parseFloat(amount) / (1 + parseFloat(this.$store.state.misc.settings.tax_rate_perc))
    },
    async openLineItemsDialog(account){
      this.loading_items = true;
      this.show_transaction_dialog = true;
      this.line_items_title = account.name;
      if(account.id !== null && account.id !== undefined){
        this.line_items = await accountingAPI.getAccountLineItems(this.fromDate, this.toDate, account.id, null, null);
      }
      else if(account.division !== null && account.division !== undefined){
        this.line_items = await accountingAPI.getAccountLineItems(this.fromDate, this.toDate, null, account.division, true);
      }
      this.setTotal();
      this.loading_items = false;
    },
    closeLineItemsDialog(){
      this.line_items = [];
      this.show_transaction_dialog = false;
    },
    setTotal(){
        let total = 0;
        for (const [index, line_item] of this.line_items.entries()) {
            total += line_item.qty * line_item.price;
            console.log(index);
        }
        this.line_item_total = total;
    }
  },
  components: {
    'report-header': ReportHeader,
    'report-title': ReportTitle,
    'invoice-line-item-dialog': InvoiceLineItemsDialog
  }
}
</script>
